export enum EFileTypes {
  XDP = 'XDP',
  WORD = 'WORD',
  PDF = 'PDF',
  PDF_A = 'PDF_A',
  PDF_FLAT = 'PDF_FLAT',
  PDF_MUSTER = 'PDF_MUSTER'
}
